"use strict";
import { randomString } from "../utils";
const clickHandlers = /* @__PURE__ */ new Map();
if (typeof document !== "undefined") {
  document.addEventListener("click", (event) => {
    clickHandlers.forEach((handler) => {
      handler(event);
    });
  });
}
export default class OnClickOutside {
  constructor(ignoreElems, onClickOutside) {
    this.onClickOutside = onClickOutside;
    this.handlerId = randomString();
    this.ignoreElemsSelector = ignoreElems.join(",");
  }
  startListening() {
    clickHandlers.set(this.handlerId, (event) => {
      if (this.outsideIgnorableElems(event.target)) {
        this.stopListening();
        return this.onClickOutside();
      }
    });
  }
  stopListening() {
    clickHandlers.delete(this.handlerId);
  }
  outsideIgnorableElems(target) {
    return !target.matches(this.ignoreElemsSelector) && this.parents(target, this.ignoreElemsSelector).length === 0;
  }
  parents(element, selector) {
    const parents = [];
    let node = element;
    do {
      node = node.parentNode;
      if (node instanceof Element && selector && node.matches(selector)) {
        parents.push(node);
      }
    } while (node && node !== document);
    return parents;
  }
}
